import { getCachedMaintenanceConfig } from './getCachedMaintenanceConfig'
import type { MaintenanceStatusApiResponse } from './types'

const emptyPayload = (): MaintenanceStatusApiResponse => ({
    apps: {},
    bypassIPs: [],
    appName: '',
    currentAppStatus: null,
})

export const getMaintenanceStatusPayload = async (): Promise<MaintenanceStatusApiResponse> => {
    try {
        const config = await getCachedMaintenanceConfig()
        const appName = process.env.APP_NAME || ''
        return {
            ...config,
            appName,
            currentAppStatus: config.apps[appName] || null,
        }
    } catch {
        return emptyPayload()
    }
}
